<h2 class="default-dialog-header font-weight-normal" mat-dialog-title>
	<span fxFlex> {{ dialogHeader }} </span>
</h2>
<mat-divider></mat-divider>

<mat-dialog-content class="default-dialog-content">
	<form
		(keydown.enter)="$event.preventDefault()"
		[formGroup]="rateDetailsForm"
		class="full-width"
	>
		<ng-container *ngIf="showRateForm">
			<!-- CN-8312: "Who did you talk to?" — typeahead over the carrier's
			     existing contacts. The mat-autocomplete suggests matches by first
			     name / last name / email; the input remains free-form so users
			     can enter someone not yet in the contact list. -->
			<div fxLayout="row" fxLayoutGap="1rem" class="m-t-1">
				<div fxFlex>
					<mat-form-field class="full-width">
						<mat-label>Who did you talk to?</mat-label>
						<input
							autocomplete="off"
							formControlName="contactName"
							matInput
							placeholder="Enter name or email"
							[matAutocomplete]="contactAutocomplete"
						/>
						<mat-autocomplete
							#contactAutocomplete="matAutocomplete"
							[displayWith]="displayContact"
							class="engage-contact-autocomplete"
							(optionSelected)="onContactSelected($event.option.value)"
						>
							<mat-option
								*ngFor="let contact of filteredContacts"
								[value]="contact"
								class="engage-contact-option"
							>
								<span class="engage-contact-option__name">{{
									contactDisplayName(contact)
								}}</span>
								<span
									class="engage-contact-option__email"
									*ngIf="contact.emailAddress && contactDisplayName(contact) !== contact.emailAddress"
									>{{ contact.emailAddress }}</span
								>
							</mat-option>
						</mat-autocomplete>
						<mat-error *ngIf="rateDetailsForm.get('contactName').hasError('required')">
							Contact name is required
						</mat-error>
					</mat-form-field>
				</div>
			</div>

			<!-- CN-8312: Carrier Rate and Rate Received on the same row -->
			<div fxLayout="row" fxLayoutGap="1rem">
				<div fxFlex>
					<mat-form-field class="full-width">
						<input
							autocomplete="off"
							formControlName="desiredPrice"
							matInput
							placeholder="Carrier Rate"
						/>
					</mat-form-field>
				</div>

				<div fxFlex>
					<mat-form-field class="full-width">
						<input
							(click)="picker1.open()"
							[formControl]="carrierRespondedAt"
							[matDatepicker]="picker1"
							matInput
							placeholder="Rate Received"
						/>
						<mat-datepicker-toggle [for]="picker1" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker1></mat-datepicker>
					</mat-form-field>
				</div>

				<!-- CN-8661: optional rate expiration date, alongside the rate input -->
				<div fxFlex *ngIf="showExpirationDate">
					<mat-form-field class="full-width">
						<input
							(click)="picker2.open()"
							[formControl]="expirationDate"
							[matDatepicker]="picker2"
							[min]="minExpirationDate"
							autocomplete="off"
							matInput
							placeholder="Expiration date"
						/>
						<mat-datepicker-toggle [for]="picker2" matSuffix tabIndex="-1"></mat-datepicker-toggle>
						<mat-datepicker #picker2></mat-datepicker>
					</mat-form-field>
				</div>
			</div>
		</ng-container>

		<!-- CN-8312: Notes textarea — rendered whenever showNotes is true so it
		     also appears in the remove-from-engaged "Add note and remove" flow
		     where showRateForm is false. Notes are optional in both flows. -->
		<div fxLayout="row" *ngIf="showNotes">
			<mat-form-field class="full-width" appearance="outline">
				<mat-label>Notes</mat-label>
				<textarea
					matInput
					formControlName="notes"
					placeholder="Add notes about the call..."
					rows="3"
				></textarea>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>

<mat-dialog-actions class="default-dialog-action">
	<!-- Explicit flex CSS (engage-dialog-actions) rather than fxLayoutAlign: this
	     dialog lives in CarriersDialogModule, which doesn't import FlexLayoutModule,
	     so the fx* directives were no-ops and the buttons rendered left-aligned. -->
	<div class="engage-dialog-actions">
		<button
			type="button"
			class="primary-text text-underline engage-dialog-cancel"
			(click)="closeDialog(null)"
		>
			Cancel
		</button>
		<button
			(click)="submitForm()"
			color="primary"
			mat-raised-button
			[disabled]="isFormSubmitted || (showRateForm && rateDetailsForm.invalid)"
		>
			{{ submitButtonText }}
		</button>
	</div>
</mat-dialog-actions>
